import { colors } from 'ui/theme/colors';

export const WIDGET_COLORS = {
  blue: '#1D4ED8',
  green: '#15843E',
  red: '#DA362B',
  gray: colors.gray[600],
};
